var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 14.3L10.7 10C12.6 7.70001 12.3 4.20001 10 2.30001C7.70001 0.400014 4.20001 0.700014 2.30001 3.00001C0.400014 5.30001 0.700014 8.80001 3.00001 10.7C5.00001 12.4 8.00001 12.4 10 10.7L14.3 15L15 14.3ZM2.00001 6.50001C2.00001 4.00001 4.00001 2.00001 6.50001 2.00001C9.00001 2.00001 11 4.00001 11 6.50001C11 9.00001 9.00001 11 6.50001 11C4.00001 11 2.00001 9.00001 2.00001 6.50001Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.45806bf3c517c62d2d53a3b5dbd77632.svg";
export { ForwardRef as ReactComponent };